export default __webpack_public_path__ + "static/media/AvenirNextW04-Bold.ee208e4d.woff";